
import { Outlet } from "react-router-dom";
import { AuthContainer, AuthWrapper, Card, LogoContainer, LogoImage, LogoImageText } from "./Components";
const AuthLayout = () => {
    return (
        <AuthContainer>
            <AuthWrapper>
                <LogoContainer>
                    <LogoImage src="/assets/images/logo.png" />
                    <LogoImageText>YOUR FEEL-GOOD NETWORK</LogoImageText>
                </LogoContainer>
                
                <Card>
                    <Outlet />
                </Card>
            </AuthWrapper>
        </AuthContainer>
    )
}
export default AuthLayout;